import React from "react";

// style imports
import "./footer.scss";

// assets imports
import IgIcon from "assets/icons/ig.png";
import FacebookIcon from "assets/icons/facebook.png";
import LinkedinIcon from "assets/icons/linkedin.png";
import TwitterIcon from "assets/icons/twitter.png";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__container">
        <p className="footer__copyrigth">©2021 Digital reservation</p>
        <section className="footer__contact__icons">
          <img src={FacebookIcon} alt="Facebook logo" />
          <img src={LinkedinIcon} alt="Linkedin logo" />
          <img src={TwitterIcon} alt="Twitter logo" />
          <img src={IgIcon} alt="Instagram logo" />
        </section>
      </div>
    </div>
  );
};

export default Footer;
